import React from 'react'
import { makeStyles } from '@material-ui/core/styles';
import InfoCards from './InfoCards';

const useStyles = makeStyles({
    heroSection: {
        paddingTop: "80px",
        paddingBottom: "80px",
        backgroundColor: '#e8f1f5',
        '@media only screen and (max-width: 768px)': {
            paddingTop: "60px",
            paddingBottom: "60px",
            textAlign: 'center',
        },
        '@media only screen and (max-width: 480px)': {
            paddingTop: "40px",
            paddingBottom: "40px",
        },
    },
    heroLeft: {
        display: "grid",
        justifyContent: "center",
        alignItems: "center",
        height: "100%",
        '& img': {
            '@media only screen and (max-width: 768px)': {
                maxWidth: '80%',
                marginLeft: 'auto',
                marginRight: 'auto',
                display: 'none',
            },
        },
    },
    heroRight: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        height: "100%",
        '& h1': {
            fontSize: '60px',
            color: 'var(--primary-color)',
            '@media only screen and (max-width: 768px)': {
                fontSize: '40px'
            },
            '@media only screen and (max-width: 400px)': {
                fontSize: '30px'
            },
        },
        '& h2': {
            color: 'var(--secondary-color)',
            '& span': {
                // color: 'var(--primary-color)',
            },
        },
        '& .workshop-desc': {
            fontSize: '18px',
            marginBottom: '0px',
            '@media only screen and (max-width: 768px)': {
                fontSize: '15px',
            },
        },
    },
    cta: {
        padding: '10px 20px',
        borderRadius: "5px",
        backgroundColor: "var(--primary-color)",
        cursor: "pointer",
        color: "#fff",
        marginRight: "auto",
        marginLeft: "15px",
        boxShadow: '0 0 10px rgba(38,75,132, 0.3)',
        "&:hover": {
            backgroundColor: "var(--primary-color-hover)",
        },
        '@media only screen and (max-width: 768px)': {
            marginLeft: "auto",
        },
    },
})

function Hero() {
    var classes = useStyles()

    return (
        <div className={classes.heroSection}>
            <div className="container">
                <div className="row" style={{flexDirection: 'row-reverse'}}>
                    <div className="col-lg-6">
                        <div className={classes.heroLeft}>
                            {/* <img src="/pitchbattle/images/rocket.png" alt="" /> */}
                            <img src="/pitchbattle/images/hero-illustration.png" alt="" />
                            
                        </div>
                    </div>
                    <div className="col-lg-6">
                        <div className={classes.heroRight}>
                            <h1>Next-Gen Entrepreneurship Bootcamp</h1>
                            <h2><span>L</span>earn. <span>E</span>ngage. <span>A</span>ccelerate. <span>D</span>isrupt.</h2>
                            <p className="workshop-desc">Unlock Your Next Adventure - An immersive month-long virtual Startup Bootcamp for Students & Aspiring Entrepreneurs</p>
                            <InfoCards />
                            <div className={classes.cta + " cta-btn"}>
                            Register now to become an agent of change 
                            {/* <span style={{textDecoration: 'line-through',}}>₹699</span> */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Hero
